module.exports = __webpack_public_path__ + "static/img/co-host-cobinhood.0491021.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/co-host-cobinhood.png
// module id = 7W1r
// module chunks = 0